<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="flex flex-col justify-between md:flex-row">
        <h1 class="text-black title-6 md:title-3">Consulta externos</h1>
        <div class="flex flex-col gap-3 pt-3 md:gap-5 md:items-end md:flex-row md:pt-0">
            <div>
                <p class="font-light title-11">Pagarés válidos otorgados</p>
                <p class="md:text-right title-6">{{ header.TOTAL }}</p>
            </div>
            <div>
                <p class="font-light title-11">Total monto financiado</p>
                <p class="md:text-right title-6">{{ header.MONTO_TOTAL | currency: 'CLP':'symbol-narrow':'0.0-0':'es-cl' }}</p>
            </div>
            <div>
                <p class="font-light title-11">Impuesto total mes</p>
                <p class="md:text-right title-6">{{ header.IMPUESTO_TOTAL | currency: 'CLP':'symbol-narrow':'0.0-0':'es-cl' }}</p>
            </div>
        </div>
    </div>

    <div class="flex flex-col items-center justify-center w-full gap-5 py-5 md:pt-10 md:flex-row">
        <mat-form-field appearance="fill" class="w-full md:flex-1">
            <mat-label>Estado pagaré</mat-label>
            <mat-select class="h-[54px]" [(ngModel)]="estadoSelected" (selectionChange)="listar()">
                <mat-option *ngFor="let estado of estadosPagare" [value]="estado.ID_ESTADO">
                    {{ estado.NOMBRE_ESTADO || 'Seleccione' }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full md:w-72">
            <mat-label class="px-1">Desde &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Hasta</mat-label>
            <mat-date-range-input [rangePicker]="picker" class="py-[15px] title-9 font-semibold">
                <input matStartDate placeholder="Fecha inicio" [(ngModel)]="start" #dateRangeStart />
                <input
                    matEndDate
                    placeholder="Fecha fin"
                    [(ngModel)]="end"
                    #dateRangeEnd
                    (dateChange)="dateRangeChange($event, dateRangeStart, dateRangeEnd)" />
            </mat-date-range-input>

            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker class="bg-red-500"></mat-date-range-picker>
        </mat-form-field>
    </div>

    <app-mat-custom-table (action)="onTableAction($event)" [use_selection]="false" [use_detail]="true" [dataset]="dataSource" [columns]="columns">
    </app-mat-custom-table>

    <div class="grid grid-cols-1 gap-5 pt-5 md:px-5 md:grid-cols-2 md:gap-0">
        <button mat-flat-button color="primary" class="w-full transition-all duration-300 ease-in-out md:w-36" (click)="descargarExcel()">
            Descargar
        </button>
    </div>
</main>
